import React, { useEffect, useState, useRef } from 'react';
import { usePartnerContext } from '../../components/Context/PartnerContext';
import ConfirmDialog from '../../views/ConfirmDialog';
import { useSnackbar } from '.././SnackBar';
import { Tabs, Tab, Box, Typography, Button, TextField, IconButton, InputAdornment } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useNavigate } from 'react-router-dom';
import { Label } from '@mui/icons-material';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
const EditPartnerDetails = () => {

    const { showSnackbar } = useSnackbar();
    const { partner, EditPartners, deletePartner, EnablePartner, RegenerateActivationLink } = usePartnerContext();
    const statusRef = useRef('');
    const navigate = useNavigate();
    const styles = { inputDisabled: { border: 'none', background: 'none' } };

    const [open, setOpen] = useState(false);
    const [snackbaropen, setSnackbarOpen] = useState(false);
    const [regeneratingLink, setRegeneratingLink] = useState(false);
    const handleCopy = () => {
        showSnackbar("copied to clipboard", "success");

        navigator.clipboard.writeText(partner.activationLink);
    };

    const handleRegenerateLink = async () => {
        setRegeneratingLink(true);
        try {
            await RegenerateActivationLink(partner.id);
            showSnackbar('Activation link regenerated and emailed to the partner.', 'success');
        } catch (error) {
            showSnackbar('Failed to regenerate activation link.', 'error');
            console.error('Failed to regenerate activation link:', error);
        } finally {
            setRegeneratingLink(false);
        }
    };


    const handelEdit = () => {

        // Navigate to the edit form with the branch ID
        navigate(`/editpartner/${partner.id}/true`, { state: { partner: partner } });
    };

    const handleActivatePartner = (event) => {
        const isActive = event.target.checked;
        partner.isActive = isActive;
        setOpen(true); // Open the confirmation dialog
    };

    const handleClose = () => {
        partner.isActive = partner.isActive ? false : true;
        setOpen(false); // Close the confirmation dialog
    };

    const handleConfirm = () => {

        ActivatePartner();
        setOpen(false); // Close the confirmation dialog
    };

    const ActivatePartner = async () => {

        const status = partner.isVerified ? statusRef.current.checked : partner.isVerified;


        try {
            debugger;
            const partnerdata = {
                id: partner.id,
                partnerID: partner.partnerID,
                partnerName: partner.partnerName,
                contactNumber: partner.contactNumber,
                email: partner.email,
                contactPerson: partner.contactPerson,
                isVerified: partner.isVerified,
                isActive: status,
                streetName: partner.street,
                buildingNumber: partner.buildingNo,
                neighborhood: partner.neighborhood,
                city: partner.city,
                state: partner.state,
                zipcode: partner.zipcode,
                country: partner.country,
                offlineServiceAvailable: partner.offlineServiceAvailable,
            };

            // Call AddModel with the necessary data
            await EnablePartner(partnerdata.id);

            showSnackbar('Partner Updated successfully!'); // Notify success
        } catch (error) {
            showSnackbar('Error Updating Partner. Please try again.', "error");
            console.error('Error Updating Partner:', error);
        }
    };

    const [bottomTabIndex, setBottomValue] = React.useState('1');
    const [topTabIndex, setTopValue] = React.useState('1');
    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 3 }}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }
    const handleBottomTabChange = (event, newValue) => {

        setBottomValue(newValue);
    };
    const handleTopTabChange = (event, newValue) => {

        setTopValue(newValue);
    };
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }
    const [confirmOpen, setConfirmOpen] = useState(false);

    const handleDeleteClick = () => {
        setConfirmOpen(true); // Open the confirmation dialog
    };

    const handleConfirmClose = () => {
        setConfirmOpen(false); // Close the confirmation dialog
    };

    const handleConfirmDelete = async () => {
        setConfirmOpen(false); // Close the confirmation dialog
        if (partner.id) {
            deletePartner(partner.id);
            showSnackbar('Partner deleted successfully', 'success');
            navigate('/addpartner');// Delete the selected brand
        }

    };

    const handleDownload = (url) => {
        if (url) {
            const link = document.createElement('a');
            link.href = url;
            link.download = url.split('/').pop(); // Extracts file name from URL
            link.click();
        }
    };

    return (
        <div>
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1></h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="/admin">Home</a></li>
                            <li className="breadcrumb-item"><a href='/partner'>Partner</a></li>
                            <li className="breadcrumb-item active"><a href=''>Edit Partner</a></li>
                        </ol>
                    </nav>
                </div>
                <section className="section">
                    <div className="row">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <nav className="navbar navbar-expand-lg navbar-light">
                                        <div className="container-fluid">



                                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                                <ul className="navbar-nav me-auto mb-2 mb-lg-0">

                                                    <h4 className="mb-3">Partner Details</h4>
                                                </ul>
                                                <Button
                                                    variant="contained"
                                                    style={{ backgroundColor: '#02176D', color: 'white', marginRight: '10px' }}
                                                    onClick={handleDeleteClick}
                                                    className="right-button"
                                                >
                                                    Delete Partner
                                                </Button>

                                                <Button className="right-button"
                                                    variant="contained"
                                                    style={{ backgroundColor: '#02176D', color: 'white' }}
                                                    color="primary"
                                                    onClick={handelEdit} >
                                                    Edit
                                                </Button>
                                            </div>
                                        </div>
                                    </nav>

                                    <ConfirmDialog
                                        open={open}
                                        onClose={handleClose}
                                        onConfirm={handleConfirm}
                                        title="Confirm Deactivate/Activate"
                                        content="Are you sure you want to Deactivate/Activate this Partner?"
                                    />


                                    <div className="container my-4">


                                        {/* Always Visible Partner Information */}
                                        <div className="row mb-3">
                                            <div className="col-md-4"><strong>Partner ID:</strong></div>
                                            <div className="col-md-8" >{partner.partnerID}</div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-4"><strong>Partner Name:</strong></div>
                                            <div className="col-md-8" >{partner.partnerName}</div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-4"><strong>Contact Number:</strong></div>
                                            <div className="col-md-8"  >{partner.contactNumber}</div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-4"><strong>Email:</strong></div>
                                            <div className="col-md-8"  >{partner.email}</div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-4"><strong>Contact Person:</strong></div>
                                            <div className="col-md-8"  >{partner.contactPerson}</div>
                                        </div>
                                        {/* <div className="row mb-3">
                                            <div className="col-md-4"><strong>Status:</strong></div>
                                            <div className="col-md-8"  >{partner.status}</div>
                                        </div> */}
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <strong>Partner Class:</strong>
                                            </div>
                                            <div className="col-md-8"  >{partner.partnerClass}</div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <strong>Offline Service Available :</strong>
                                            </div>
                                            <div className="col-md-8"  >
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="flexSwitchCheckDefault"
                                                       readOnly
                                                        checked={partner.offlineServiceAvailable}
                                                    />
                                                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault">

                                                        {partner.offlineServiceAvailable ? 'Active' : 'Not Active'}
                                                    </label>
                                                </div>
                                            </div>

                                        </div>


                                        <div className="row mb-3">
                                            <label htmlFor="inputPassword" className="col-sm-2 col-form-label"><strong>Partner Icon:</strong></label>
                                            <div className="col-sm-10">
                                                <img height="60px" width="60px" alt="" src={partner.icon}></img>

                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-4">
                                                <strong>Activation link:</strong>
                                            </div>
                                            <div className="col-md-8">
                                                {partner.isVerified && (
                                                    <p className="text-muted small mb-2">
                                                        Partner is verified. Regenerate to issue a new activation link and reset verification.
                                                    </p>
                                                )}
                                                {!partner.isVerified && partner.activationLink && (
                                                    <div className="input-group mb-2">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            value={partner.activationLink}
                                                            readOnly
                                                        />
                                                        <button
                                                            className="btn btn-outline-primary"
                                                            onClick={handleCopy}
                                                            type="button"
                                                        >
                                                            <i className="bi bi-clipboard"></i>
                                                        </button>
                                                    </div>
                                                )}
                                                <button
                                                    className="btn btn-outline-secondary btn-sm"
                                                    onClick={handleRegenerateLink}
                                                    type="button"
                                                    disabled={regeneratingLink}
                                                >
                                                    {regeneratingLink ? 'Regenerating...' : 'Regenerate link'}
                                                </button>
                                            </div>
                                        </div>

                                        <div className="row" style={{ position: 'relative' }}>
                                            <div className="col-12 text-center">
                                                {/* Button Positioned in the Top-Right Corner */}
                                                <div className="col-sm-4" style={{
                                                    position: 'absolute',
                                                    bottom: '200px',  // Distance from the top
                                                    right: '10px' // Distance from the right
                                                }}>

                                                </div>

                                                {/* Confirmation Dialog */}
                                                <Dialog
                                                    open={confirmOpen}
                                                    onClose={handleConfirmClose}
                                                >
                                                    <DialogTitle>Confirm Deletion</DialogTitle>
                                                    <DialogContent>
                                                        <DialogContentText>
                                                            Are you sure you want to delete this partner? This action cannot be undone.
                                                        </DialogContentText>
                                                    </DialogContent>
                                                    <DialogActions>
                                                        <Button onClick={handleConfirmClose} color="secondary">
                                                            Cancel
                                                        </Button>
                                                        <Button onClick={handleConfirmDelete} color="primary" autoFocus>
                                                            Confirm
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog>
                                            </div>
                                        </div>
                                    </div>
                                    {partner.isVerified && <div className="row mb-3">
                                        <div className="col-md-4">
                                            <strong>enable/disable</strong>
                                        </div>
                                        <div className="col-md-8 form-check form-switch">
                                            <input className="form-check-input" type="checkbox" checked={partner.isActive} id="flexSwitchCheckDefault" defaultValue={partner.status} ref={statusRef} onChange={handleActivatePartner}></input>
                                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Activate/Deactivate Partner</label>
                                        </div>
                                    </div>}

                                    {/* Tabs Section for Company and Bank Information */}
                                    <ul className="nav nav-tabs mt-4" id="partnerDetailsTabs" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <a className="nav-link active"
                                                id="location-info-tab"
                                                data-bs-toggle="tab"
                                                href="#location-info"
                                                role="tab"
                                                aria-controls="location-info"
                                                aria-selected="false"
                                            >
                                                Location Information
                                            </a>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <a
                                                className="nav-link" id="company-info-tab" data-bs-toggle="tab" href="#company-info" role="tab" aria-controls="company-info" aria-selected="true">Company Information</a>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <a className="nav-link" id="bank-info-tab" data-bs-toggle="tab" href="#bank-info" role="tab" aria-controls="bank-info" aria-selected="false">Bank Information</a>
                                        </li>
                                    </ul>

                                    {/* Tab Content */}
                                    <div className="tab-content mt-3" id="partnerDetailsTabsContent">
                                        {/* Location Information Tab */}
                                        <div
                                            className="tab-pane fade show active"
                                            id="location-info"
                                            role="tabpanel"
                                            aria-labelledby="location-info-tab"
                                        >
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>Street:</strong></div>
                                                <div className="col-md-8"  >{partner.streetName}</div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>Building Number:</strong></div>
                                                <div className="col-md-8"  >{partner.buildingNumber}</div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>Neighborhood:</strong></div>
                                                <div className="col-md-8"  >{partner.neighborhood}</div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>City:</strong></div>
                                                <div className="col-md-8"  >{partner.city}</div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>State:</strong></div>
                                                <div className="col-md-8"  >{partner.state}</div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>Zipcode:</strong></div>
                                                <div className="col-md-8"  >{partner.zipcode}</div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>Country:</strong></div>
                                                <div className="col-md-8"  >{partner.country}</div>
                                            </div>
                                        </div>

                                        {/* Company Information Tab */}
                                        <div className="tab-pane fade" id="company-info" role="tabpanel" aria-labelledby="company-info-tab">
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>Company Name:</strong></div>
                                                <div className="col-md-8"  >{partner.companyName}</div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>Company Name (Arabic):</strong></div>
                                                <div className="col-md-8"  >{partner.companyNameAR}</div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>Company Short Name:</strong></div>
                                                <div className="col-md-8"  >{partner.companyShortName}</div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>Website:</strong></div>
                                                <div className="col-md-8"  >{partner.website}</div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>VAT Number:</strong></div>
                                                <div className="col-md-8"  >{partner.vatNumber}</div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>CR Number:</strong></div>
                                                <div className="col-md-8"  >{partner.crNumber}</div>
                                            </div>
                                        </div>

                                        {/* Bank Information Tab */}
                                        <div className="tab-pane fade" id="bank-info" role="tabpanel" aria-labelledby="bank-info-tab">
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>Bank Name:</strong></div>
                                                <div className="col-md-8"  >{partner.bankName}</div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>Account Number:</strong></div>
                                                <div className="col-md-8"  >{partner.accountNumber}</div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>IBAN:</strong></div>
                                                <div className="col-md-8"  >{partner.iban}</div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>Account Holder Name:</strong></div>
                                                <div className="col-md-8"  >{partner.accountHolderFullName}</div>
                                            </div>
                                            <div className="row mb-3">
                                                <div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-4">
                                                            <strong>Account Holder Name:</strong>
                                                        </div>
                                                        <div className="col-md-8">{partner.accountHolderFullName}</div>
                                                    </div>



                                                    <div className="row mb-3">
                                                        <div className="col-md-4"><strong>Document Name:</strong></div>
                                                        <div className="col-md-8"  >{partner.attachmentName}</div>
                                                    </div>

                                                    <div className="col-md-8">
                                                        {partner.attachment ? (
                                                            <button
                                                                onClick={() => handleDownload(partner.attachment)}
                                                                className="btn btn-link text-primary p-0"
                                                            >
                                                                Download Attachment
                                                            </button>
                                                        ) : (
                                                            <span>No attachment available</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mb-3">
                                                <div className="col-md-4"><strong>Currency:</strong></div>
                                                <div className="col-md-8"  >{partner.currency}</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </main>


        </div>
    )
};

export default EditPartnerDetails;